import {PaletteColor, useTheme} from "@mui/material";
import {grey} from "@mui/material/colors";
import {ArrowDropDown} from "@mui/icons-material";
import {css} from "@emotion/css";

export function HeaderActionButton(props: {
    icon: any;
    badgeContent: any;
    badgeColor?: any;
    onClick(e: any): void;
    label: string;
}) {
    const theme = useTheme();
    const badgeColor = theme.palette[props.badgeColor || "error"] as PaletteColor;

    return (
        <button
            className={buttonCss}
            onClick={(e) => props.onClick(e)}
        >
            <div style={{height: 2}} />
            <div style={{
                fontSize: "0.7rem",
                textAlign: "center",
                backgroundColor: badgeColor.main,
                color: badgeColor.contrastText,
                paddingLeft: 4,
                paddingRight: 4,
                borderRadius: 6,
                fontWeight: "bold",
                visibility: !!props.badgeContent ? "visible" : "hidden",
            }}>
                {props.badgeContent || <>&nbsp;</>}
            </div>
            <div style={{height: 2}} />
            <div style={{fontSize: "1.2rem"}}>
                {props.icon}
            </div>
            <div style={{
                display: "flex",
                flexDirection: "row",
            }}>
                <div style={{
                    fontSize: "0.7rem",
                    flex: 1,
                    textAlign: 'center',
                    paddingLeft: "0.7em",
                }}>
                    {props.label}
                </div>
                <div style={{
                    fontSize: "1rem",
                    height: "1em",
                    width: "1em",
                }}>
                    <ArrowDropDown fontSize="inherit" />
                </div>
            </div>
        </button>
    )
}

const buttonCss = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "none",
    border: "1px solid " + grey["200"],
    cursor: "pointer",
    padding: 0,

    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.1)"
    }
})